import React from 'react';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import { connect } from 'react-redux';
import previewCommands from '../utils/PreviewCommands';
import configuration from '../../constants/Configuration';
import appParameters from '../utils/AppParameters';
import modeType from '../../constants/ModeConstants';
import platformDetection from '../../components/utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import slidesPreloader from '../utils/SlidesPreloader';
import slidesPreloaderNew from '../utils/SlidesPreloaderNew';
import audioUtils from '../utils/AudioUtils';
import fullScreenManager from '../utils/FullScreenManager';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import audioVolumeUtils from '../utils/AudioVolumeUtils';
import { VolumeSlider } from '../menus/VolumeSlider';
import videoUtils from '../utils/VideoUtils';
import locales from '../../locales/LocalesManager';

const Button = React.createClass({
    getInitialState () {
        if (this.props.index == 2)
            previewCommands.forceUpdateForPlayButton = this.forceUpdateForPlayButton;

        return {
            isOver: false
        };
    },
    onButtonMouseIn() {
        switch (this.props.index) {
            case 0: {
                hoverManager.show(this.refs.holder, 'firstSlide');
                break;
            }
            case 1: {
                hoverManager.show(this.refs.holder, 'previousSlide');
                break;
            }
            case 2: {
                if (playController.isPlaying)
                    hoverManager.show(this.refs.holder, 'previewModePauseCartoon');
                else
                    hoverManager.show(this.refs.holder, 'previewModePlayCartoon');
                break;
            }
            case 3: {
                hoverManager.show(this.refs.holder, 'nextSlide');
                break;
            }
            case 4: {
                hoverManager.show(this.refs.holder, 'lastSlide');
                break;
            }
            case 5: {
                if (this.props.src.indexOf('normalScreen') != -1)
                    hoverManager.show(this.refs.holder, 'normalScreen');
                else if (this.props.src.indexOf('fullScreen') != -1)
                    hoverManager.show(this.refs.holder, 'fullScreen');
                else
                    hoverManager.show(this.refs.holder, 'exitPreview');
                break;
            }
            case 7: { // Volume
                hoverManager.show(this.refs.holder, 'changeVolume');
                break;
            }
        }

        this.setState({
            isOver: true
        });
    },
    getButtonAriaLabel() {
        var text = '';

        switch (this.props.index) {
            case 0: {
                text = locales.getCaption('firstSlide', 'hover');
                break;
            }
            case 1: {
                text = locales.getCaption('previousSlide', 'hover');
                break;
            }
            case 2: {
                if (playController.isPlaying)
                    text = locales.getCaption('previewModePauseCartoon', 'hover');
                else
                    text = locales.getCaption('previewModePlayCartoon', 'hover');
                break;
            }
            case 3: {
                text = locales.getCaption('nextSlide', 'hover');
                break;
            }
            case 4: {
                text = locales.getCaption('lastSlide', 'hover');
                break;
            }
            case 5: {
                if (this.props.src.indexOf('normalScreen') != -1)
                    text = locales.getCaption('normalScreen', 'hover');
                else if (this.props.src.indexOf('fullScreen') != -1)
                    text = locales.getCaption('fullScreen', 'hover');
                else
                    text = locales.getCaption('exitPreview', 'hover');
                break;
            }
            case 7: { // Volume
                text = locales.getCaption('changeVolume', 'hover');
                break;
            }
        }

        return text;
    },
    onButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (this.props.index == 7) {
            if (this.props.handleVolume)
                this.props.handleVolume();
        } else {
            previewCommands.executeCommand(this.props.index, this.props.volume);

            if (this.props.index == 2) {// Update icon for pause/play button
                this.props.refreshView();
            }
        }
    },
    forceUpdateForPlayButton() {
        this.forceUpdate();
    },
    getSoundIcon() {
        const state = storeManager.getState();
        var soundVolume = state.production.storySoundVolume;

        if (soundVolume == undefined)
            soundVolume = 0.5;

        var volumeIcon = 'fa fa-volume-down fa-2x';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off fa-2x';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down fa-2x';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up fa-2x';

        return volumeIcon;
    },
    render() {
        var leftPosition;
        const middle = this.props.menuWidth / 2;
        const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
        const buttonSize = isMobileValue ? 28 : properties.PREVIEW_HEIGHT;

        switch (this.props.index) {
            case 0: {
                leftPosition = middle - buttonSize/ 2 - properties.PREVIEW_BUTTONS_GAP * 2 - buttonSize * 2;
                break;
            }
            case 1: {
                leftPosition = middle - buttonSize / 2 - properties.PREVIEW_BUTTONS_GAP - buttonSize;
                break;
            }
            case 2: {
                leftPosition = middle - buttonSize / 2;
                break;
            }
            case 3: {
                leftPosition = middle + buttonSize / 2 + properties.PREVIEW_BUTTONS_GAP;
                break;
            }
            case 4: {
                leftPosition = middle + buttonSize / 2 + properties.PREVIEW_BUTTONS_GAP * 2 + buttonSize;
                break;
            }
            case 5: {
                    leftPosition = this.props.menuWidth - buttonSize - properties.PREVIEW_BUTTONS_GAP;
                break;
            }
            case 7: {
                    leftPosition = this.props.menuWidth - 2 * buttonSize - 2 * properties.PREVIEW_BUTTONS_GAP;
                break;
            }
        }

        var scale = 1;
        var offset = 0;

        if (appParameters.getMode() != modeType.PLAYER){
            if (this.props.index == 5) // is close button
                scale = 166 / 123;
        } else {
            if (fullScreenManager.isFullScreenMode() && this.props.index == 5)
                offset = 12;
        }

        var buttonStyle = {
            width: buttonSize,
            height: properties.PREVIEW_HEIGHT,
            position: 'absolute',
            left: leftPosition,
            top: 0,
            background: 'none',
            borderStyle: 'none'
        };

        var iconSrc = this.props.src;

        if (this.props.index == 2)
        {
            if (!previewCommands.isPlaying) {
                iconSrc = this.props.src;
            }
            else
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/pause';
        }

        iconSrc = iconSrc + '.png';

        const iconWidth = properties.PREVIEW_BUTTON_SIZE * scale + offset;
        const iconHeight = properties.PREVIEW_BUTTON_SIZE + offset;
        var opacity = 1;

        if (this.state.isOver == true)
            opacity = 0.4;

        var iconStyle = {
            position: 'absolute',
            top: properties.PREVIEW_HEIGHT / 2 - iconHeight / 2,
            left: buttonSize / 2 - iconWidth / 2,
            width: iconWidth,
            height: iconHeight,
            opacity: opacity
        };

        if (previewCommands.isPlaying && this.props.index != 2 && this.props.index != 5 && this.props.index != 7) {
            iconStyle.opacity = 0.4;
            buttonStyle.pointerEvents = 'none';
        }

        var iconElement;

        if (this.props.index == 7) { // volume button
            iconStyle = {
                position: 'absolute',
                top: 11,
                left: 10,
                color: '#4b4c4c',
                opacity: opacity
            };

            iconElement = <i style={iconStyle} className={this.getSoundIcon()}></i>;
        } else {
            iconElement = <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>;
        }

        var elementId = 'audioElementVolume_' + this.props.index;

        if (this.props.index == 2)
            elementId = 'playButtonElement';

        return (
            <button aria-label={this.getButtonAriaLabel()} ref='holder' id={elementId} style={buttonStyle} onTouchStart={this.onClick} onClick={this.onClick} onMouseOver={this.onButtonMouseIn} onMouseOut={this.onButtonMouseOut}>
                {iconElement}
            </button>
        );
    }
});

export const PreviewMenuContent = React.createClass({
    getInitialState() {
        setTimeout(this.initPlayer, 10);

        return {
            isMounted: false,
            openVolumeSlider: false
        };
    },
    initPlayer() {
        playController.updateAudioElements();
        previewCommands.goToFirstSlide(true);
    },
    componentDidMount() {
        this.setState({
            isMounted: true
        });

        document.addEventListener('mousedown', this.onCloseVolumeSlider);
        document.addEventListener('touchstart', this.onCloseVolumeSlider);

        if (!playController.isAudioEditorAvailable()) {
            if (!audioVolumeUtils.useVolumeFunctionality()) {
                audioUtils.initSlideSound();
                audioUtils.initSlideSoundEffect();
                audioUtils.initStorySound(this.onStorySoundEnd);
            }
        } else {
            previewCommands.initSequence();
        }

        previewCommands.refreshFunction = this.refreshView;
        fullScreenManager.refreshFunction = this.refreshView;
        playController.refreshControlBar = this.refreshView;

        if (fullScreenManager.isIOSMode() && fullScreenManager.isFullScreenMode())
            fullScreenManager.addFullScreenEventsForIOS();
    },
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
        document.removeEventListener('touchstart', this.onCloseVolumeSlider);

        if (!playController.isAudioEditorAvailable()) {
            if (audioVolumeUtils.useVolumeFunctionality()) {
                audioVolumeUtils.executeMediaAction('storySound', 0, false);
                audioVolumeUtils.executeMediaAction('slideSound', 0, false);
                audioVolumeUtils.executeMediaAction('slideSoundEffect', 0, false);
            } else {
                audioUtils.cleanSlideSound();
                audioUtils.cleanSlideSoundEffect();
                audioUtils.cleanStorySound();
            }
        }
    },
    handleVolume() {
        this.setState({
            openVolumeSlider: true
        });
    },
    onCloseVolumeSlider (e) {
        const target = e.target;

        var volume = 'audioElementVolume_7';

        if (target == undefined || (target && target.id == volume) || (target.parentElement && target.parentElement.id == volume))
            return;

        if (target.id && target.id.indexOf('volumeIcon') != -1) {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    getSoundSource() {
        var val;

        if (this.props.storySound)
            val = this.props.storySound.href;

        val = videoUtils.checkCacheBreaker(val);

        if (audioVolumeUtils.useVolumeFunctionality())
            audioVolumeUtils.checkSound(val, 'storySound');
        else
            audioUtils.updateHrefForStorySound(val);

        return val;
    },
    onStorySoundEnd() {
        if (previewCommands.isPlaying) {
            previewCommands.endStorySound();
        }
    },
    refreshView() {
        if (this.state.isMounted == true)
            this.forceUpdate();
    },
    preloadAssets() {
        setTimeout(this.preload, 3);
    },
    preload() {
        if (playController.isAudioEditorAvailable())
            slidesPreloaderNew.preloadAssets(true);
        else
            slidesPreloader.preloadAssets(true);
    },
    render() {
        this.preloadAssets();

        const width = configuration.CANVAS_WIDTH * this.props.scaleProperties.scale;
        var previewHeight = properties.PREVIEW_HEIGHT;
        var controlBarOpacity = 1;
        var controlBarVisible = 1;

        if (fullScreenManager.isFullScreenMode() == true) {
            controlBarOpacity = 0.6;

            if (fullScreenManager.isControlBarVisible() == false)
                controlBarVisible = 0;
        }

        const menuStyle = {
            position: 'absolute',
            width: width,
            height: properties.PREVIEW_HEIGHT,
            top: this.props.windowHeight - previewHeight,
            left: this.props.scaleProperties.topX,
            opacity: controlBarVisible,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none'
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: '#edeeef',
            width: width,
            opacity: controlBarOpacity,
            height: properties.PREVIEW_HEIGHT,
            top: 0,
            left: 0
        };

        var elements = [];
        var closeSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/close';

        if (appParameters.getMode() == modeType.PLAYER) {
            if (platformDetection.isIOS()) {
                if (previewCommands.isIOSFullScreen)
                    closeSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/normalScreen';
                else
                    closeSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/fullScreen';
            } else {
                if (fullScreenManager.isFullScreenMode())
                    closeSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/normalScreen';
                else
                    closeSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/fullScreen';
            }
        }

        elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={0} key={'preview0'} src={appParameters.RESOURCES_LOCATION() + 'assets/player/start'} menuWidth={width} refreshView={this.refreshView}/>);
        elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={1} key={'preview1'} src={appParameters.RESOURCES_LOCATION() + 'assets/player/back'} menuWidth={width} refreshView={this.refreshView}/>);
        elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={2} key={'preview2'} src={appParameters.RESOURCES_LOCATION() + 'assets/player/play'} menuWidth={width} refreshView={this.refreshView}/>);
        elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={3} key={'preview3'} src={appParameters.RESOURCES_LOCATION() + 'assets/player/next'} menuWidth={width} refreshView={this.refreshView}/>);
        elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={4} key={'preview4'} src={appParameters.RESOURCES_LOCATION() + 'assets/player/end'} menuWidth={width} refreshView={this.refreshView}/>);

        var fullScreenButton;

        if (appParameters.isEmbedded == true) {
           // not include fullScreen button
        } else {
            fullScreenButton = <Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={5} key={'preview5'} src={closeSrc} menuWidth={width}/>;
        }

        var soundsHolder;

        if (!playController.isAudioEditorAvailable()) {
            soundsHolder = <div>
                <audio id='storySound' className='audioItem' src={this.getSoundSource()} preload='auto' playsInline/>
                <audio id='slideSound' className='audioItem' preload='auto' playsInline/>
                <audio id='slideSoundEffect' className='audioItem' preload='auto' playsInline/>
            </div>;
        }

        var slidesElementStyle = {
            color: 'black',
            fontSize: 17,
            fontWeight: 'bold',
            cursor: 'default',
            position: 'absolute',
            textAlign: 'center',
            width: 70,
            height: 100,
            left: 0,
            top: 13
        };

        if (previewCommands.isPlayMode()) {
            var slidesElement = <span style={slidesElementStyle} key={'preview9'}>{previewCommands.getSlidesText()}</span>;
            elements.push(slidesElement);

            elements.push(<Button dispatch={this.props.dispatch} volume={this.props.storySoundVolume} index={7} key={'preview7'} menuWidth={width} handleVolume={this.handleVolume}/>);

            const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
            const volumeSliderOffset = isMobileValue ? 85 : 102;

            var slider = <VolumeSlider dispatch={this.props.dispatch} visible={this.state.openVolumeSlider} type={'cartoonistUnexportedVolume'} positionLeft={width - volumeSliderOffset} key={'preview10'}/>
            elements.push(slider);
        }

        return (
            <div id='previewMenu' style={menuStyle}>
                {soundsHolder}
                <div style={backgroundStyle}/>
                <div>
                    {elements}
                    {fullScreenButton}
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const storySound = state.production.storySound;
    const storySoundVolume = state.production.storySoundVolume;
    let windowHeight = state.production.windowHeight;
    let currentSlideIndex = state.currentSlide.currentSlideIndex;

    if (!(windowHeight > 0))
        windowHeight = window.innerHeight;

    return {
        storySound,
        storySoundVolume,
        windowHeight,
        currentSlideIndex
    };
}

export const PreviewMenu = connect(mapStateToProps)(PreviewMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/PreviewMenu.js
 **/